// AIDEV-NOTE: Tabela de dados com paginacao server-side usando MUI DataGrid
import {
  DataGrid,
  type GridColDef,
  type GridPaginationModel,
  type GridValidRowModel
} from '@mui/x-data-grid';
import { Box } from '@mui/material';

interface DataTableProps<T extends GridValidRowModel> {
  rows: T[];
  columns: GridColDef[];
  total: number;
  paginationModel: GridPaginationModel;
  onPaginationModelChange: (model: GridPaginationModel) => void;
  loading?: boolean;
  getRowId?: (row: T) => string | number;
}

export function DataTable<T extends GridValidRowModel>({
  rows,
  columns,
  total,
  paginationModel,
  onPaginationModelChange,
  loading = false,
  getRowId
}: DataTableProps<T>) {
  return (
    <Box sx={{ width: '100%', minHeight: 400 }}>
      <DataGrid
        rows={rows}
        columns={columns}
        rowCount={total}
        paginationMode="server"
        paginationModel={paginationModel}
        onPaginationModelChange={onPaginationModelChange}
        loading={loading}
        pageSizeOptions={[10, 25, 50]}
        getRowId={getRowId as ((row: GridValidRowModel) => string | number) | undefined}
        disableRowSelectionOnClick
        autoHeight
        sx={{ bgcolor: 'background.paper' }}
      />
    </Box>
  );
}
